// in Proteus

const StarRating4i = function () {
	let triggers,
	
	init = () => {
		triggers = document.getElementsByClassName("miniReviewLink");
		for(var i = 0; i < triggers.length; i++){
			triggers[i].removeEventListener('click', toggleRatingsBreakdown);
			triggers[i].addEventListener('click', toggleRatingsBreakdown);

		}
	},
	toggleRatingsBreakdown = (e) => {
		e.preventDefault();
		let reviewTrigger = e.currentTarget;
		if (document.getElementsByClassName('showRating').length == 0) {
			open(reviewTrigger);
		} else {
			closeAnyOpen();
		}
	},
	open = (trigger) => {
		closeAnyOpen();
		let dropdown = trigger.nextElementSibling;
		let dropdownLink = dropdown.getElementsByTagName("a")[0];
		
		dropdown.inert = false;
		dropdown.classList.add("showRating");
		dropdown.classList.remove("hide");
		document.addEventListener('keydown', closeOnEsc);
		//if main product detail rating, we will go to current page rating, else follow the href
		const isDetailsPage = dropdown.parentNode.parentNode.parentNode.classList.contains("ratingPlaceholder");
		if(isDetailsPage) dropdownLink.addEventListener('click', goToReviews);
	},
	close = (trigger) => {
		trigger.classList.add("hide");
		trigger.classList.remove("showRating");
		trigger.inert = true;

		document.removeEventListener('keydown', closeOnEsc);
	},
	closeAnyOpen = () => {
		let openElements = document.getElementsByClassName('showRating');
		if(openElements.length > 0) {
			for(var i = 0; i < openElements.length; i++){
			close(openElements[i]);
			}
		}
	},
	closeOnEsc = (e) => {
		if (e.keyCode == 27) closeAnyOpen();
	},
	waitForTabsToAppear = (activatedTabId) => {
		document.querySelector("#detailTabs").scrollIntoView();
		
		//allow the tabs to 'appear'
		const callback = function(mutationsList, observer) {
			for (let i = 0; i < mutationsList.length; i++) {
 				if (mutationsList[i].type === 'childList') {
					let tab = document.getElementById(activatedTabId);
 					tab.click();
 					tab.focus();
 					tabObserver.disconnect();
				}
			}
		};
		const tabObserver = new MutationObserver(callback);
		tabObserver.observe(document.getElementById('detailTabs'), { 
			childList: true, 
			subtree: true 
		});
	},
	goToReviews = (e) => {
		e.preventDefault();
		//Why is this here? It was spelled wrong so didn't work in the past.
		if (document.querySelector('a.anchor[name="reviews"]')) { }//return; }
		closeAnyOpen();

		//if the tabs haven't appeared on the page yet
		const reviewTab = document.getElementById("reviewsTS") ? document.getElementById("reviewsTS") : "";
		if(reviewTab == ""){
			waitForTabsToAppear("reviewsTS");
		}else{
			reviewTab.click();
			reviewTab.focus();
		}		
		e.currentTarget.parentNode.removeEventListener('click', goToReviews);
	};
	return {
		Init: init
	};
};